import React from "react";
import { Input, Row, Typography, Select, Form, Divider, Col } from "antd";
import { labelConfig, staticConfig } from "../../systemAdmin.config";
import { BOM } from "../../../../services/definedMethod";

const { Title } = Typography;

const TillAuthorizationForm = (props) => {
  const {
    onFinish,
    form,
    formData,
    officeData,
    branchConfigList,
    setSelectedbranchConfigValue,
  } = props;
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={{
        allowTellerTillAuth: true,
        allowVaultTillAuth: true,
      }}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.authorizationInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.vault}
            name={"vaultId"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.vault),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase(),
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.vault,
                "select",
              )}
              options={branchConfigList}
              onChange={(val) => setSelectedbranchConfigValue(val)} // val is now an object { label, value }
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name="description" label={labelConfig.tillProfileName}>
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.tillProfileName,
              )}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.denominationTracking}
            name={"allowDenomTracking"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase(),
                )
              }
              showSearch
              options={staticConfig.statusData}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.printReceipt}
            name={"printTransactionReceipt"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase(),
                )
              }
              showSearch
              options={staticConfig.statusData}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.transactionReversal}
            name={"allowTransactionReversal"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase(),
                )
              }
              showSearch
              options={staticConfig.statusData}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TillAuthorizationForm;
